import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import franchiseAdminAPI from "../../api/franchiseAdminAPI";

const Profile = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const email = Cookies.get("userEmail");
    if (!email) {
      setError("User email not found in cookies");
      setLoading(false);
      return;
    }
    franchiseAdminAPI
      .getFranchiseDetailsByEmail(email)
      .then((res) => {
        setDetails(res.data);
         if (res.data?.referralCode) {
          Cookies.set("referralCode", res.data.referralCode, { expires: 7 });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to fetch franchise details");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="profile-page" style={{ height: "100%" }}>Loading...</div>;
  }

  if (error) {
    return <div className="profile-page" style={{ height: "100%" }}>{error}</div>;
  }

  return (
    <div className="profile-page scrollable-container" style={{ height: "100%" }}>
      <div className="profile-card">
        <h2>
          <strong>Profile</strong>
        </h2>
        <p>Franchise details</p>
        <p>This is the profile page.</p>
        <ul className="profile-details">
          <li><strong>Organization:</strong> {details.organization}</li>
          <li><strong>Location:</strong> {details.location}</li>
          <li><strong>Created By:</strong> {details.createdBy}</li>
          <li><strong>Created At:</strong> {new Date(details.createdAt).toLocaleString()}</li>
          {details.parentId && (
            <>
              <li><strong>Parent ID:</strong> {details.parentId}</li>
              <li><strong>Parent Organization:</strong> {details.parentOrganization}</li>
              <li><strong>Parent Location:</strong> {details.parentLocation}</li>
            </>
          )}
          <li><strong>Referral Code:</strong> {details.referralCode}</li>

          
          <li><strong>Country:</strong> {details.country}</li>
        </ul>
      </div>
    </div>
  );
};

export default Profile;
